export default [
  {
    headerName: '',
    width: 30,
    field: 'rowIndex',
    hidden: true,
    suppressMovable: true,
    cellStyle: {
      textAlign: 'center',
      padding: '5px 0',
      color: '#595959',
      backgroundColor: '#f0f0f0',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '500',
      boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
    },
  },
  {
    headerName: '考试名称',
    field: 'title',
    width: 20,
    cellStyle: {
      textAlign: 'center',
    },
    style: {
      alignment: {vertical: 'bottom', horizontal: 'left'},
    },
  },
  {
    headerName: '考试分类',
    field: 'examCategoryName'
  },
  {
    headerName: '考试类型',
    field: 'examType'
  },
  {
    headerName: '考试开始时间',
    field: 'startDate'
  },
  {
    headerName: '考试结束时间',
    field: 'endDate'
  },
  {
    headerName: '组织名称',
    field: 'orgName'
  },
  {
    headerName: '组织编码',
    field: 'orgCode'
  },
  {
    headerName: '组织类型名称',
    field: 'orgTypeName'
  },
  {
    headerName: '岗位',
    field: 'positionName'
  },
  {
    headerName: '应参考人数',
    field: 'shoudCount'
  },
  {
    headerName: '已参考人数',
    field: 'factCount'
  },
  {
    headerName: '参考率',
    field: 'rate'
  },
  {
    headerName: '通过人数',
    field: 'passCount'
  },
  {
    headerName: '通过率',
    field: 'passRate'
  },
]